<template>
  <button
    type="button"
    @click="$emit('update:modelValue', !modelValue)"
    class="w-10 h-[22px] rounded-full transition-colors relative flex-shrink-0"
    :class="modelValue ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'"
    :aria-pressed="modelValue"
  >
    <span
      class="absolute top-0.5 left-0.5 w-[18px] h-[18px] bg-white rounded-full transition-transform shadow-sm"
      :class="modelValue ? 'translate-x-[18px]' : ''"
    ></span>
  </button>
</template>

<script setup>
defineProps({ modelValue: { type: Boolean, default: false } })
defineEmits(['update:modelValue'])
</script>
